<template>
<div class="modal is-large is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="default-settings-title">
                <span class="account-name">Databases auto-synchronization</span>
                <span class="default-settings-subtitle">Configure the auto-synchronization of the databases running on this server.</span>
            </div>

            <div class="backup" style="margin-bottom: 35px;">
                <div class="columns is-multiline">
                    <div class="column is-full" style="margin-top:-10px;">
                        <div class="notification is-default" style="font-size:13px;">
                            Weap.io can keep the databases running on this server synchronized with the Weap.io dashboard. This means 
                            that when a new database will be created on this server, it will be automatically available on Weap.io using 
                            the default backup frequency & retention of the server. The same happens when a database is deleted from 
                            the server: it will be deleted from your Weap.io dashboard as well.
                        </div>
                    </div>

                    <div class="column is-full">
                        <div class="field" @click="toggleEnableDatabasesAutoSynchronization">
                            <input v-model="enableDatabasesAutoSynchronization" type="checkbox" class="switch is-rounded is-info">
                            <label style="margin-top:-5px; font-size: 15px;">Enable databases auto-synchronization</label>
                        </div>
                    </div>

                    <div class="column is-6">
                        <div class="field">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth">
                                    <select v-model="backupsBehaviour">
                                        <option value="keep_backups">Keep the backups after a database is deleted</option>
                                        <option value="delete_backups">Delete the backups after a database is deleted</option>
                                    </select>
                                </div>
                                <div class="icon is-left is-custom-icon-left">
                                    <font-awesome-icon icon="hdd"/>
                                </div>
                            </div>
                        </div>
                        <span class="help" style="display:inline-block;margin-top:8px;">Choose what should happen with the backups when a database is deleted from this server.</span>
                    </div>

                    <!-- <div class="column is-full">
                        <div class="field" style="margin-bottom:15px;">
                            <div class="control has-icons-left">
                                <div class="select is-fullwidth">
                                    <select v-model="selectedEncryptionKey" :disabled="!enableEncryption">
                                        <option v-for="encryptionKey in encryptionKeys" v-bind:key="encryptionKey.id" :value="encryptionKey.id">{{ encryptionKey.name }}</option>
                                    </select>
                                </div>
                                <div class="icon is-left is-custom-icon-left">
                                    <font-awesome-icon icon="key"/>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>

            <div class="columns is-multiline" style="margin-top: 10px;">
                <div class="column is-3">
                    <div @click="update" :disabled="saveButtonDisabled" :class="{ 'is-loading': updating }" class="button custom-button-size is-fullwidth is-info">{{ saveButtonText }}</div>
                </div>
                <div class="column is-3">
                    <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger" :disabled="updating">Cancel</div>
                </div>
            </div>
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';

export default {
    props: ['server'],

    data() {
        return {
            enableDatabasesAutoSynchronization: false,
            backupsBehaviour: 'keep_backups',
            updating: false,
        }
    },

    mounted() {
        this.enableDatabasesAutoSynchronization = this.server.auto_synchronize_databases;
        this.backupsBehaviour = this.server.backups_behaviour;
        this.listenEvents();
    },

    methods: {
        close() {
            if (!this.loading && !this.updating) {
                Event.$emit('configureDatabasesAutoSynchronizationModalClosed');
            }
        },
        
        toggleEnableDatabasesAutoSynchronization() {
            this.enableDatabasesAutoSynchronization = !this.enableDatabasesAutoSynchronization;
        },

        update() {
            if (this.updating) {
                return;
            }

            this.updating = true;

            let data = {
                auto_synchronize_databases: this.enableDatabasesAutoSynchronization,
                backups_behaviour: this.backupsBehaviour,
            };

            Api().put('servers/' + this.server.id + '/databases-auto-synchronization', data)
                .then((success) => {
                    Event.$emit('refreshServer', () => {
                        this.close();
                        swal('Success!', 'Databases auto-synchronization settings updated successfully.', 'success');
                    });
                })
                .finally(() => {
                    this.updating = false;
                });
        },

        getEncryptionKeys() {
            Api().get('encryption-keys')
                .then((success) => {
                    this.encryptionKeys = success.data.data;
                    Vue.nextTick(() => {
                        for (var i = 0; i <= this.encryptionKeys.length; i++) {
                            if (typeof this.encryptionKeys[i] !== 'undefined' && this.encryptionKeys[i].id == this.database.encryption_key_id) {
                                this.selectedEncryptionKey = this.encryptionKeys[i].id;
                            }
                        }
                    });
                })
        },

        toggleEnableEncryption() {
            this.enableEncryption = !this.enableEncryption;
        },

        changeEncryption() {
            if (this.saveButtonDisabled || this.changingEncryptionKey) {
                return;
            }

            this.changingEncryptionKey = true;
            let endpoint = 'databases/' + this.database.id + '/encryption';

            if (this.enableEncryption) {
                Api().put(endpoint, { encryption_key_id: this.selectedEncryptionKey })
                    .then((success) => {
                        Event.$emit('refreshDatabase', () => {
                            this.close();
                            swal('Success!', 'The database encryption key was changed successfully.', 'success');
                        });
                    })
                    .finally(() => {
                        this.changingEncryptionKey = false;
                    });
            } else {
                Api().delete(endpoint)
                    .then(() => {
                        Event.$emit('refreshDatabase', () => {
                            this.close();
                            swal('Success!', 'The database encryption was disabled.', 'success');
                        });
                    })
                    .finally(() => {
                        this.changingEncryptionKey = false;
                    });
            }
        },

        listenEvents() {
            //
        },
    },

    computed: {
        saveButtonText() {
            return 'Save changes';
        },

        saveButtonDisabled() {
            return this.updating;
        },
    },
}
</script>
